<template>
  <footer class="footer-legal" :class="{ 'footer-legal--dark': dark }">
    <a :href="`${GENERAL_TERMS_LINK}?lang=${lang}`" target="_blank" rel="noopener">{{ $t('links.generalTerms') }}</a>
    <span aria-hidden="true">·</span>
    <a :href="`${PRIVACY_POLICY_LINK}?lang=${lang}`" target="_blank" rel="noopener">{{ $t('links.privacyPolicy') }}</a>
    <span aria-hidden="true">·</span>
    <a :href="`${LEGAL_NOTICE_LINK}?lang=${lang}`" target="_blank" rel="noopener">{{ $t('links.legal') }}</a>
  </footer>
</template>

<script>
import { GENERAL_TERMS_LINK, PRIVACY_POLICY_LINK, LEGAL_NOTICE_LINK } from '~/plugins/constants.js'

export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      GENERAL_TERMS_LINK,
      PRIVACY_POLICY_LINK,
      LEGAL_NOTICE_LINK,
    }
  },
  computed: {
    lang () {
      return this.$i18n.locale
    },
  },
}
</script>

<style lang="scss" scoped>
.footer-legal {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  gap: 0.1rem;
  padding: 0.3rem;
  font-size: 0.65rem;
  color: black;
  flex-wrap: wrap;
  text-align: center;
  z-index: $z-index-footer;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.756);

  &--dark {
    color: white;
    background-color: black;
  }

  a:hover {
    text-decoration: underline;
  }
}
</style>
